import React from 'react';
import './AboutBanner.css';

function AboutBanner() {
  return (
    <div className="about-banner-container">
      <div className="about-banner-placing">
        <span className="about-banner-title">
          Discover a world of knowledge, led by expert educators
        </span>
      </div>
    </div>
  );
}

export default AboutBanner;
